// rules.jsx
import React, { useEffect, useMemo, useState } from 'react';
import '../fonts/breuer-headline.css';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { initQuestions } from '../../functions/setUserQuestions';
import { selectAdminToken } from '../../admin/sessionSlice';
import { processQuestions } from '../../admin/questionSlice';
import { setBackButtonUrl } from '../uiSlice';

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [redirect, setRedirect] = useState("/welcome");
  const adminToken = useSelector(selectAdminToken);
  const [isLoading, setIsLoading] = useState(false);
  
  console.log(themeData);

  useEffect(() => {
    if (!themeData || !user || !adminToken) return;

    // Welcome / full-house themes have no quiz config (no noOfQuestion) — skip setUserQuestions.
    const baseQuestions = parseInt(
      themeData.noOfQuestion ?? themeData.no_of_questions,
      10
    );
    const needsQuizInit = Number.isFinite(baseQuestions) && baseQuestions >= 1;

    setIsLoading(true);

    if (!needsQuizInit) {
      return;
    }

    dispatch(processQuestions())
      .unwrap()
      .then(() => {
        return initQuestions({
          userId: user.userId,
          email: user.email,
          fullName: user.name,
          themeName: themeData.themename,
          token: adminToken,
        });
      })
      .then((data) => {
        console.log('Init response:', data);
      })
      .catch((err) => {
        console.error('Error in process→init chain:', err);
      });
  }, [themeData, user, adminToken, dispatch]);

  useEffect(() => {
    if (!themeData) return;
    
    setRedirect("/welcome");
      }, [themeData]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate(redirect);
  };

  const rulesTextColor = useMemo(() => {
    const raw =
      themeData?.landing_page_title_color ??
      themeData?.landing_page_title_colour;
    if (raw == null || raw === '') return undefined;
    const c = String(raw).trim();
    return c || undefined;
  }, [themeData]);

  const nextButtonTextColor = useMemo(() => {
    const raw = themeData?.button_Textcolor ?? themeData?.button_text_color;
    if (raw == null || raw === '') return undefined;
    const c = String(raw).trim();
    return c || undefined;
  }, [themeData]);

  const nextButtonBackground = useMemo(() => {
    const raw = themeData?.begin_button_color ?? themeData?.button_color;
    if (raw == null || String(raw).trim() === '') return undefined;
    return String(raw).trim();
  }, [themeData]);

  const bonusPointsValue = useMemo(() => {
    const n = parseInt(themeData?.bonus_point, 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }, [themeData]);

  if (!isLoading) {
  return (
      <div className='quiz-loader-container'>
       <div className="quiz-loader"></div>
      </div>
  );
}

  return (
    <>
      <div className="user-rules-page">
        <div className="user-rules-stack">
          <fieldset
            className="user-rules-fieldset"
            style={rulesTextColor ? { color: rulesTextColor } : undefined}
          >
            <legend className="user-rules-heading">How to Play</legend>
            <ul className="user-rules-list">
              {(themeData?.rules ?? []).map((rule, index) => (
                <li key={index}>{rule}</li>
              ))}
            </ul>
          </fieldset>
          {bonusPointsValue > 0 ? (
            <p
              className="user-rules-bonus"
              style={rulesTextColor ? { color: rulesTextColor } : undefined}
            >
              Bonus points available: {bonusPointsValue}
            </p>
          ) : null}
          <button
            type="button"
            className="user-next-button"
            onClick={handleNextClick}
            style={{
              ...(nextButtonBackground ? { background: nextButtonBackground } : null),
              ...(nextButtonTextColor
                ? { color: nextButtonTextColor, borderColor: nextButtonTextColor }
                : null),
            }}
          >
            Next
          </button>
        </div>
      </div>
    </>
  )
}

export default UserRules;